module.exports = __webpack_public_path__ + "static/media/29.4b75f1d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/29.jpg
// module id = 590
// module chunks = 0